/**
 * <TutorLivesHistorySkeleton> — la forme de « Mon historique de lives » à son premier chargement :
 * le champ de recherche, puis des séances en lignes de carte — la date, la description, le statut
 * et le montant. Quatre séances : ce qu'un téléphone montre. `<TutorHistoryMoreSkeleton>` est le pied
 * de la pagination : deux lignes du même type.
 */
import React from "react"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { CardList, CardListRow } from "../../molecules/CardList"
import { TEXT_INPUT_HEIGHT } from "../../atoms/TextInput/TextInput"

function TutorHistoryRowSkeleton() {
    return (
        <CardList>
            <CardListRow>
                <Stack gap="2">
                    <Skeleton textSize="text-md" width={190} />
                    <Skeleton textSize="text-sm" width="70%" />
                    <Row gap="2" align="center">
                        <Skeleton shape="chip" width={80} />
                        <Skeleton textSize="text-sm" width={36} />
                    </Row>
                </Stack>
            </CardListRow>
        </CardList>
    )
}

export function TutorHistoryMoreSkeleton() {
    return (
        <Stack gap="4">
            <TutorHistoryRowSkeleton />
            <TutorHistoryRowSkeleton />
        </Stack>
    )
}

export function TutorLivesHistorySkeleton() {
    return (
        <Stack gap="4">
            <Skeleton shape="block" height={TEXT_INPUT_HEIGHT} radius="md" />
            {[0, 1, 2, 3].map((index) => (
                <TutorHistoryRowSkeleton key={index} />
            ))}
        </Stack>
    )
}
